import Text from '../../../atoms/Text';
import PairIcons from '../../../molecules/PairIcons';

interface IPairWithIconsProps {
  chain: string
  name: string
  base_address: string
  quote_address: string
  base_slug?: string;
  quote_slug?: string;
}

const PairWithIcons = ({ chain, base_address, quote_address, name, base_slug, quote_slug }: IPairWithIconsProps) =>
  (<span className='tableCell'>
    <PairIcons
      chain={chain}
      base_address={base_address}
      quote_address={quote_address}
      base_slug={base_slug}
      quote_slug={quote_slug}
      pair={name}
    />
    <Text size={12} className='text--weight-500 text--grey-600'>{name}</Text>
  </span>);

export default PairWithIcons;